import React, { useState, useEffect } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import {
  resetLinkedList,
  getLabelAndValue,
  resetList,
} from "../../CommonFuntion/SchemaValidation";
import { titleCase } from "../../CommonFuntion/SchemaValidation";
import { GetDivisionByFactoryCode } from "../../CommonFuntion/SchemaAPICalls";

const CssSelectField = styled(Select)({
  ".MuiSelect-select": {},
  "& label.Mui-focused": {
    color: "#ec0000c4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#ec0000c4",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#ec0000c4",
    },
    "&:hover fieldset": {
      borderColor: "#ec0000c4",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#ec0000c4",
    },
  },
  "& div.MuiSelect-nativeInput": {
    fontSize: 12,
  },
});

export function SingleDropDown(props) {
  const {
    name,
    label,
    options,
    value,
    tagName,
    prefix,
    validation,
    schemaPageId,
    schemaResult,
    schemaItem,
    childLists,
    setChildOpt,
    childPageId,
    childItemId,
    formData,
    mandatoryByLabelName,
    disableByLabelName,
    handleResetELCList,
    handleELLValue,
    childOpt,
    setLLIValue,
    LLIValue,
    user_id,
    divisionID,
    store_grp,
    factoryDivisionConfig,
  } = props;
  const factoryTag = factoryDivisionConfig?.factoryTagName || "";
  const divisionTag = factoryDivisionConfig?.divisionTagName || "";
  const [options2, setOptions2] = useState(options);
  const { setFieldValue, values } = useFormikContext();
  useEffect(() => {
    let LLIItem = schemaResult?.find((x) => x.prefix === "LLI");
    if (LLIItem) {
      let childItem = schemaResult?.find(
        (x) => x.schemaItem === LLIItem.childItemId
      );

      if (childItem.schemaItem === schemaItem && formData[LLIItem.fieldName]) {
        const optionValue = LLIItem.options.find(
          (x) => x.label === formData[LLIItem.fieldName]
        )?.value;
        const optionsData = Object.entries(LLIItem.childLists)?.find(
          ([key]) => key === optionValue
        )[1];
        setOptions2(optionsData);
      }
    }
    if (
      childOpt &&
      childOpt.childPageId === schemaPageId &&
      childOpt.childItemId === schemaItem
    ) {
      setOptions2(childOpt.optionsData);
    }
  }, [formData, LLIValue, childOpt]);

  // Helper: load divisions for a given factory code value
  const loadDivisions = (factoryValue) => {
    const divisionField = divisionTag
      ? schemaResult?.find(
          (field) => field.tagName === divisionTag && field.prefix === "SLI"
        )
      : null;
    if (!divisionField) return;

    setFieldValue(divisionField.fieldName, "");
    GetDivisionByFactoryCode(
      factoryValue,
      user_id || "",
      "",
      divisionID || "",
      store_grp || ""
    )
      .then((locations) => {
        const locs = Array.isArray(locations) ? locations : [];
        const locationOptions = locs.map((loc) => ({
          label:
            loc.DivisionId ||
            loc.divisionId ||
            loc.CustomerId ||
            loc.customerId ||
            "",
          value: loc.CustDiv || loc.custDiv || "",
        }));
        setChildOpt({
          childPageId: schemaPageId,
          childItemId: divisionField.schemaItem,
          optionsData: locationOptions,
        });
        // Auto-select if only 1 division returned
        if (locationOptions.length === 1) {
          setFieldValue(divisionField.fieldName, locationOptions[0].value);
        }
      })
      .catch(() => {
        setChildOpt({
          childPageId: schemaPageId,
          childItemId: divisionField.schemaItem,
          optionsData: [],
        });
      });
  };

  // Auto-select factory if only 1 option, then trigger division load
  useEffect(() => {
    if (
      factoryTag &&
      tagName === factoryTag &&
      options2?.length === 1 &&
      !values[name]
    ) {
      const singleValue = options2[0].value;
      setFieldValue(name, singleValue);
      loadDivisions(singleValue);
    }
  }, [options2]);

  // On load: if factory already has a saved value (page reload / amend), load division options
  useEffect(() => {
    if (
      factoryTag &&
      tagName === factoryTag &&
      values[name] &&
      options2?.length > 0
    ) {
      loadDivisions(values[name]);
    }
    // Run only when factory options are first populated
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options2?.length]);

  const id = `${tagName}-input`;
  const handleChange = (e, selected) => {
    const { value } = e.target;

    setFieldValue([name], value);

    // FACTORY → Division cascading: when factory code changes, load divisions
    if (factoryTag && tagName === factoryTag && value) {
      loadDivisions(value);
    } else if (factoryTag && tagName === factoryTag && !value) {
      // Factory cleared: clear Division options
      const divisionField = divisionTag
        ? schemaResult?.find(
            (field) => field.tagName === divisionTag && field.prefix === "SLI"
          )
        : null;
      if (divisionField) {
        setChildOpt({
          childPageId: schemaPageId,
          childItemId: divisionField.schemaItem,
          optionsData: [],
        });
        setFieldValue(divisionField.fieldName, "");
      }
    }
  };

  return (
    <>
      <div className="flex-container">
        <div className="control-bottom-border">
          {label && (
            <label
              className="font-css"
              id={`${tagName || name}-input`}
              data-testid="dropdown-label"
            >
              {titleCase(label.replace("_", " "))}

              {(validation?.mandatory ||
                (validation?.mandatoryByLabelName &&
                  validation?.mandatoryByLabelName ===
                    mandatoryByLabelName)) && (
                <span
                  className="mandatory-validation"
                  data-testid="mandatory-indicator"
                >
                  {"*"}
                </span>
              )}
            </label>
          )}
        </div>

        <div className="control-bottom-border">
          <FormControl variant="standard" aria-labelledby={id}>
            <CssSelectField
              labelId={label}
              id={tagName}
              name={name}
              key={name}
              tagname={tagName}
              fieldname={name}
              prefix={prefix}
              className="control-width-font"
              style={{
                fontSize: "12px",
              }}
              onChange={handleChange}
              label={
                label
                  ? titleCase(label.split(" ")[0].replace("_", " "))
                  : undefined
              }
              value={(factoryTag && tagName === factoryTag) || (divisionTag && tagName === divisionTag) ? (values[name] || "") : (getLabelAndValue(values[name])[0] || "")}
              disabled={
                validation?.disableByLabelName &&
                validation?.disableByLabelName === disableByLabelName
              }
            >
              <MenuItem
                style={{
                  fontSize: "12px",
                }}
                value=""
              ></MenuItem>
              {options2.map((optn, index) => (
                <MenuItem
                  style={{
                    fontSize: "12px",
                  }}
                  key={index}
                  value={optn.value}
                  label={optn.label || optn.value}
                >
                  {optn.label}
                </MenuItem>
              ))}
            </CssSelectField>
          </FormControl>
          <ErrorMessage
            name={name}
            render={(msg) => <div className="is-invalid">{msg}</div>}
          />
        </div>
      </div>
    </>
  );
}
